/**
 * Kopfbereich auf schmalen Geraeten beim Scrollen ausblenden.
 *
 * Nach unten wischen versteckt ihn, nach oben wischen holt ihn zurueck. Auf
 * dem Desktop passiert nichts – dort bleibt der Header dauerhaft oben, das
 * regelt allein die CSS-Regel position: sticky.
 *
 * Ohne dieses Skript bleibt der Header sichtbar. Das ist der brauchbare
 * Ausgangszustand, kein Fehlerfall.
 */
(() => {
  const header = document.querySelector('.header--sticky');
  if (!header) return;

  // Nur ein Schwellwert, damit ein Wackeln von wenigen Pixeln – etwa durch
  // das Ein- und Ausblenden der Browserleiste auf dem Handy – den Header
  // nicht flackern laesst.
  const SCHWELLE = 8;

  let letzteHoehe = window.scrollY;
  let geplant = false;

  const pruefen = () => {
    geplant = false;
    const y = window.scrollY;
    const diff = y - letzteHoehe;

    if (Math.abs(diff) < SCHWELLE) return;

    // Bei offenem Menue nie verstecken – sonst verschwindet die Navigation
    // unter dem Finger, waehrend man in ihr scrollt.
    if (header.querySelector('details[open]')) {
      letzteHoehe = y;
      return;
    }

    // Erst ausblenden, wenn der Header ohnehin aus dem Bild gescrollt waere.
    const nachUnten = diff > 0 && y > header.offsetHeight;
    header.classList.toggle('header--hidden', nachUnten);
    letzteHoehe = y;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(pruefen);
    },
    { passive: true }
  );

  // Beim Oeffnen des Menues den Header aktiv zurueckholen. Die Sperre oben
  // friert den Zustand nur ein – war er vorher versteckt, bliebe die
  // geoeffnete Navigation sonst ausserhalb des Bildes haengen.
  const menue = header.querySelector('details');
  if (menue) {
    menue.addEventListener('toggle', () => {
      if (menue.open) {
        header.classList.remove('header--hidden');
        letzteHoehe = window.scrollY;
      }
    });
  }
})();
